/**
 * Shared form card wrapper for website forms.
 */

import { type CSSProperties, type FormEvent, type ReactNode } from "react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../ui/card";
import { Button } from "../ui/button";

interface WebsiteFormCardProps {
  title: string;
  description: string;
  onSubmit: (event: FormEvent<HTMLFormElement>) => void;
  formFields: ReactNode;
  submitLabel: string;
  submitIcon?: ReactNode;
  cancelLabel: string;
  onCancel: () => void;
  isSubmitting?: boolean;
  primaryTextStyle?: CSSProperties;
  secondaryTextStyle?: CSSProperties;
  cardClassName?: string;
  cardStyle?: CSSProperties;
  formClassName?: string;
  actionsClassName?: string;
}

export function WebsiteFormCard({
  title,
  description,
  onSubmit,
  formFields,
  submitLabel,
  submitIcon,
  cancelLabel,
  onCancel,
  isSubmitting = false,
  primaryTextStyle,
  secondaryTextStyle,
  cardClassName = "stat-card",
  cardStyle,
  formClassName = "space-y-6",
  actionsClassName = "flex gap-3 pt-4",
}: WebsiteFormCardProps) {
  return (
    <Card className={cardClassName} style={cardStyle}>
      <CardHeader>
        <CardTitle className="card-title-text" style={primaryTextStyle}>
          {title}
        </CardTitle>
        <CardDescription
          className="card-description-text"
          style={secondaryTextStyle}
        >
          {description}
        </CardDescription>
      </CardHeader>

      <CardContent>
        <form onSubmit={onSubmit} className={formClassName}>
          {formFields}

          <div className={actionsClassName}>
            <Button type="submit" className="gap-2" disabled={isSubmitting}>
              {submitIcon}
              {submitLabel}
            </Button>
            <Button type="button" variant="outline" onClick={onCancel}>
              {cancelLabel}
            </Button>
          </div>
        </form>
      </CardContent>
    </Card>
  );
}
